import { Link } from "react-router-dom";
import styles from "../styles/CategoriesGrid.module.css";

const fallbackTiles = [
  {
    title: "What We Do",
    slug: "/services",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3",
    className: styles.services,
  },
  {
    title: "Our Work",
    slug: "/our-work",
    image: "https://images.unsplash.com/photo-1501183638710-841dd1904471",
    className: styles.portfolio,
  },
  {
    title: "In the workshop",
    slug: "/workshop",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3",
    className: styles.workshop,
  },
  {
    title: "About Us",
    slug: "/about",
    image: "https://images.unsplash.com/photo-1601050690597-df0568f70950",
    className: styles.story,
  },
  {
    title: "Stairs Gallery",
    slug: "/our-work/stairs",
    image: "https://images.unsplash.com/photo-1519710164239-da123dc03ef4",
    className: styles.brochure,
  },
  {
    title: "Contact us",
    slug: "/contact",
    image: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6",
    className: styles.contact,
  },
];

const isExternal = (value = "") => /^https?:\/\//i.test(value);
const normalizeInternal = (value = "") => (value.startsWith("/") ? value : `/${value}`);

const CategoriesGrid = ({ tiles = [] }) => {
  const sourceTiles = tiles.length ? tiles : fallbackTiles;
  const orderedTiles = [...sourceTiles]
    .sort((a, b) => (a.order ?? Number.MAX_SAFE_INTEGER) - (b.order ?? Number.MAX_SAFE_INTEGER))
    .slice(0, 6);

  const classOrder = [
    styles.services,
    styles.portfolio,
    styles.workshop,
    styles.story,
    styles.brochure,
    styles.contact,
  ];

  const mappedTiles = orderedTiles.map((tile, index) => ({
    ...tile,
    className: tile.className || classOrder[index] || "",
  }));

  return (
    <section className={styles.section}>
      <div className="contentWrapper">
        <div className={styles.grid}>
          {mappedTiles.map((tile, index) => {
            const title = tile.title || `Tile ${index + 1}`;
            const slug = tile.slug || "/";
            const imgAlt = tile.imageAlt || title;
            const image = tile.image || fallbackTiles[index]?.image || fallbackTiles[0].image;
            const itemClass = `${styles.item} ${tile.className}`.trim();

            if (isExternal(slug)) {
              return (
                <a key={`${title}-${index}`} href={slug} className={itemClass} target="_blank" rel="noreferrer">
                  <img src={image} alt={imgAlt} />
                  <span>{title}</span>
                </a>
              );
            }

            return (
              <Link key={`${title}-${index}`} to={normalizeInternal(slug)} className={itemClass}>
                <img src={image} alt={imgAlt} />
                <span>{title}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoriesGrid;
